import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"
import { AssetCategory, IGetAssetCategoryDto } from "./AssetCategory"

export interface IGetAssetCategoriesDto {
    entities?: IGetAssetCategoryDto[]
    links?: IApiLink[]
}

export default class AssetCategories {
    items?: AssetCategory[]
    linkCreateAssetCategory?: IApiLink
    linkGetAssetCategoriesImported?: IApiLink

    constructor({
        entities,
        links
    }: IGetAssetCategoriesDto) {
        this.items = entities?.map(acDto => new AssetCategory(acDto))
        this.linkCreateAssetCategory = links?.find(lnk =>
            lnk.entity === ApiLinkEntity.assetCategory
            && lnk.rel === ApiLinkRel.new
        )
        this.linkGetAssetCategoriesImported = links?.find(lnk =>
            lnk.entity === ApiLinkEntity.importedAssetCategory
            && lnk.rel === ApiLinkRel.all
        )
    }
}
